var _defs, _path, _path2, _path3, _g, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 283.42,
    x2: 500.626,
    y1: 289.055,
    x1: 498.738,
    gradientUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#510000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 287.449,
    x2: 502.927,
    y1: 291.373,
    x1: 501.444,
    gradientUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 317.647,
    x2: 484.764,
    y1: 311.709,
    x1: 484.764,
    gradientUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F5F549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97C924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 317.486,
    x2: 634.411,
    y1: 317.486,
    x1: 444.509,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    id: "h"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 226.375l-63.702 110.332h127.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 484.764,
    y1: 311.709,
    x2: 484.764,
    y2: 317.647
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "x",
    gradientTransform: "scale(4.45715 .22436)",
    x1: 98.901,
    y1: 1440.155,
    x2: 124.971,
    y2: 1440.155,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 484.764,
    y1: 311.709,
    x2: 484.764,
    y2: 317.647
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 484.764,
    y1: 311.709,
    x2: 484.764,
    y2: 317.647
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "y",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(9.12405 .1096)",
    x1: 47.855,
    y1: 3054.214,
    x2: 61.745,
    y2: 3054.214
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0067c6",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 160h640v160H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248 239.463l7.983.534c.027-.39.05-.778.08-1.167l-3.14-.21c.078-1.282.185-2.563.242-3.847 1.11-.803 2.222-1.605 3.33-2.414l.098-1.48-3.51 2.55c-.12-.83-.578-1.686-1.413-1.974-.73-.265-1.625-.31-2.258.21-.803.59-.947 1.648-1.05 2.567-.14 1.742-.24 3.488-.362 5.23zm1.216-1.09c.096-1.31.155-2.623.28-3.93.1-.647.218-1.394.784-1.806.51-.34 1.267-.087 1.477.49.417 1 .232 2.1.178 3.145l-.15 2.273-2.57-.172zm-.176-11.168c2.596.606 5.193 1.212 7.79 1.82l1.77-7.584c-.37-.085-.738-.17-1.107-.257l-1.506 6.45-2.37-.554c.45-1.938.903-3.876 1.356-5.813l-1.1-.258-1.36 5.812-2.097-.49 1.45-6.208-1.113-.26c-.57 2.447-1.142 4.894-1.714 7.34zm2.806-10.462l7.556 2.628.383-1.103c-.99-.344-1.98-.69-2.972-1.033.388-1.143.813-2.274 1.17-3.427.256-.942.453-2.043-.1-2.918-.45-.648-1.25-1.063-2.04-1.038-.87.037-1.58.678-1.967 1.42-.57 1.074-.89 2.255-1.307 3.392l-.724 2.08zm1.46-.73c.404-1.133.77-2.28 1.207-3.403.273-.6.605-1.31 1.294-1.5.567-.13 1.16.306 1.21.887.14 1.068-.328 2.077-.656 3.07l-.623 1.792-2.43-.846zm2.714-8.947c1.424.827 2.836 1.674 4.27 2.486.807.435 1.832.683 2.677.196 1.153-.638 1.875-1.816 2.44-2.965.447-.968.77-2.17.202-3.16-.613-.99-1.726-1.443-2.676-2.033l-2.766-1.618c-.195.335-.39.67-.587 1.004 1.357.798 2.722 1.58 4.07 2.39.646.392 1.18 1.103 1.07 1.894-.128.942-.667 1.77-1.204 2.53-.442.618-1.186 1.116-1.975.95-.822-.16-1.49-.697-2.214-1.087l-2.72-1.59c-.195.334-.39.67-.587 1.003zm5.762-9.416l6.353 4.86c.986-1.286 1.968-2.577 2.96-3.858.57-.817 1.095-1.88.71-2.883-.35-.8-1.173-1.417-2.054-1.458-.397-.054-.916.247-1.13.38.225-.853-.473-1.655-1.26-1.88-.944-.337-1.903.27-2.528.942-.737.8-1.352 1.703-2.025 2.555l-1.025 1.34zm1.61-.24c.745-.95 1.448-1.936 2.227-2.86.362-.403.943-.86 1.505-.564.512.222.638.868.394 1.333-.39.83-1.03 1.505-1.565 2.243-.29.38-.58.76-.872 1.14-.564-.43-1.127-.86-1.69-1.292zm2.59 1.982c.77-.987 1.498-2.01 2.312-2.962.415-.435.938-.983 1.597-.858.565.13.975.74.78 1.31-.317 1.046-1.1 1.848-1.73 2.715l-.994 1.298-1.964-1.503zm3.003-10.228l5.494 5.815 4.705-4.447-.78-.826-3.765 3.556-.097.09-.07-.072-4.643-4.915zm7.043-6.162l4.876 6.342.952-.732-4.877-6.342zm7.165-4.866c-.79.492-1.428 1.068-1.918 1.74-.49.67-.753 1.37-.792 2.098-.038.73.157 1.436.587 2.126a4.116 4.116 0 0 0 1.58 1.475 3.59 3.59 0 0 0 2.14.394c.774-.087 1.646-.43 2.617-1.034.932-.58 1.593-1.25 2-2.02.39-.738.5-1.522.333-2.357l-1.106.432c.29 1.6-.742 2.367-1.896 3.1-1.807 1.1-3.568 1.02-4.647-.632-1.118-1.862.105-3.4 1.642-4.4 1.09-.68 2.167-1.146 3.19-.494l.866-.772a3.195 3.195 0 0 0-2.044-.56c-.81.046-1.655.343-2.55.902zm9.453-4.718l-.837 8.965 1.245-.502.252-2.78h.004l4.048-1.633 2.11 1.828 1.245-.503-6.82-5.876-1.247.502zm1.095.92l2.66 2.302-2.978 1.2.32-3.503zm16.439-5.865l.5 7.984c1.444-.097 2.89-.165 4.33-.285 1.135-.13 2.352-.424 3.128-1.327 1-1.11 1.143-2.77.705-4.15-.368-1.217-1.462-2.137-2.7-2.37-1.22-.235-2.464-.05-3.692.006l-2.27.143zm1.232 1.062c1.15-.06 2.297-.173 3.448-.18a2.94 2.94 0 0 1 1.83.56c.8.548 1.27 1.534 1.166 2.5-.057 1.113-.875 2.136-1.956 2.417-.618.16-1.26.205-1.893.275l-2.238.14c-.12-1.904-.24-3.808-.358-5.712zM321.33 168c-.15 2.662-.303 5.325-.455 7.987l7.773.444.065-1.133c-2.204-.126-4.408-.253-6.613-.378l.14-2.432c1.985.112 3.972.227 5.958.34l.065-1.13c-1.987-.112-3.973-.227-5.96-.34.04-.717.083-1.434.123-2.15 2.122.12 4.244.242 6.365.363l.067-1.14-7.526-.43zm20.89 3.333l-2.894 7.458 1.03.4 2.293-5.913.118-.307.128.34 2.758 7.936 1.348.522 2.893-7.458-1.032-.4-2.292 5.91-.117.303-.126-.338-2.763-7.93zm10.746 4.617l-3.636 7.125-1.07-.545 3.638-7.126zm6.034 3.535c-.776-.513-1.565-.852-2.38-1.017-.814-.165-1.56-.114-2.238.156-.68.27-1.24.74-1.687 1.42a4.116 4.116 0 0 0-.68 2.052c-.046.743.13 1.44.534 2.11.4.666 1.074 1.315 2.03 1.946.916.605 1.8.926 2.67.975a3.446 3.446 0 0 0 2.28-.68l-.855-.826c-1.332.932-2.46.315-3.608-.43-1.753-1.182-2.415-2.816-1.365-4.485 1.226-1.794 3.134-1.325 4.684-.344 1.074.708 1.945 1.49 1.78 2.693l1.063.466c.124-.715.014-1.41-.346-2.093-.378-.717-1.002-1.36-1.883-1.942zm7.618 5.745l-8.363 3.336 1.014.88 2.59-1.04.003.004 3.295 2.86-.667 2.71 1.015.88 2.127-8.75-1.015-.88zm-.32 1.393l-.84 3.417-2.424-2.106 3.264-1.31zm6.362 4.167l-6.173 5.09.743.9 2.428-2c.823.986 1.624 1.992 2.464 2.964-.257 1.347-.515 2.693-.765 4.04l.942 1.144c.267-1.422.536-2.843.804-4.264.69.567 1.702.85 2.528.402.71-.336 1.336-.982 1.373-1.805.086-1.102-.7-1.996-1.33-2.814-1.004-1.22-2.01-2.438-3.015-3.657zm-.136 1.626c.864 1.067 1.77 2.1 2.597 3.2.38.565.855 1.36.42 2.02-.36.567-1.15.517-1.632.15-.98-.66-1.627-1.67-2.392-2.547l-.978-1.187 1.986-1.637zm9.494 11.104l-8.994.413.67 1.164 2.788-.135.002.005 2.177 3.78-1.517 2.343.67 1.165 4.875-7.57-.67-1.164zm-.758 1.212l-1.912 2.953-1.602-2.783 3.514-.17zm5.89 9.378c-.5-1.357-1.288-2.747-2.623-3.426-1.485-.746-3.462-.383-4.515.925-.918 1.086-.965 2.624-.72 3.96.29 1.535.993 2.996 2.05 4.15-.2.07-.398.142-.597.214l.383 1.065c1.25-.45 2.498-.9 3.747-1.348-.486-1.35-.97-2.698-1.457-4.047-.29.104-.577.208-.866.31l1.072 2.984c-.423.15-.846.303-1.27.455-1.12-.962-1.744-2.384-2.07-3.798-.24-1.062-.25-2.334.556-3.17.924-.96 2.56-1.258 3.67-.44 1.093.802 1.71 2.1 2.022 3.388.214.848.18 1.856-.464 2.518-.18.135.105.323.154.484l.306.505a2.823 2.823 0 0 0 1.074-2.237c.023-.852-.165-1.697-.45-2.495zm2.3 6.248l-4.475.87c-.83.16-1.453.425-1.868.774-.414.35-.68.842-.807 1.497-.126.647-.108 1.442.077 2.408a.197.197 0 0 1 .004.022c.19.966.472 1.71.833 2.262.364.56.794.917 1.31 1.085.515.17 1.19.18 2.02.018l4.475-.87-.222-1.142-4.366.85c-1.96.38-2.62-.65-2.957-2.415l-.004-.022c-.35-1.763-.125-2.966 1.835-3.348l4.366-.85-.22-1.14zm2.453 13.616l-8.278-3.54.097 1.34 2.57 1.09v.005l.314 4.35-2.385 1.45.098 1.34 7.682-4.697-.097-1.34zm-1.21.76l-3.005 1.828-.232-3.203 3.237 1.375zM254.2 254.668l-1.16.306 1.284 4.874 1.16-.306zm131.626 0l1.16.305-1.282 4.874-1.16-.305zM266.574 275.19l-8.945 1.03.747 1.116 2.772-.327.002.004 2.43 3.623-1.352 2.44.748 1.116 4.344-7.886-.748-1.116zm-.674 1.262l-1.704 3.077-1.79-2.668 3.494-.41zm4.098 3.626l-5.702 5.332.76.814 4.806-4.493-2.52 6.937.873.934 6.89-2.09-4.72 4.412.762.814 5.7-5.332-1.155-1.236-7 2.09 2.62-6.774zm8.304 8.472l-4.812 6.392 6.22 4.684.684-.908-5.29-3.985 1.464-1.945 4.768 3.59.68-.903-4.768-3.59 1.296-1.722c1.698 1.28 3.395 2.557 5.093 3.835l.687-.912-6.022-4.535zm7.828 5.73l-3.768 7.058 1.03.55 1.482-2.775c1.137.6 2.26 1.224 3.408 1.803.276 1.343.55 2.685.832 4.027l1.307.698-.88-4.247c.856.26 1.898.138 2.49-.592.505-.563.847-1.354.606-2.11-.28-1.043-1.307-1.59-2.174-2.094-1.442-.776-2.89-1.543-4.332-2.316zm.493 1.556c1.206.658 2.44 1.268 3.62 1.97.548.368 1.243.874 1.174 1.62-.06.654-.766 1.003-1.363.864-1.167-.193-2.152-.89-3.192-1.41l-1.45-.773 1.21-2.27zm8.543 3.169l-3.023 7.407 1.11.453 3.024-7.407zm7.214 2.492c-.884-.294-1.734-.416-2.564-.364-.828.052-1.534.295-2.12.732-.585.436-1.004 1.037-1.26 1.81a4.116 4.116 0 0 0-.126 2.158c.15.73.502 1.356 1.065 1.898.56.54 1.38.993 2.465 1.353 1.043.346 1.98.427 2.832.248a3.445 3.445 0 0 0 2.027-1.25l-1.042-.573c-1.044 1.245-2.294.942-3.596.522-2-.69-3.063-2.094-2.482-3.98.718-2.05 2.683-2.092 4.433-1.547 1.22.404 2.266.934 2.42 2.137l1.146.174a3.192 3.192 0 0 0-.877-1.93c-.55-.594-1.32-1.054-2.323-1.387zm8.043 1.801l-5.232 7.327 1.33.192 1.616-2.275h.006l4.318.625.904 2.64 1.33.193-2.94-8.51-1.33-.192zm.484 1.344l1.14 3.328-3.177-.46 2.037-2.868zm18.269-1.288c-.914.177-1.715.486-2.414.938-.697.45-1.194 1.008-1.49 1.675-.297.668-.37 1.397-.215 2.195.142.732.46 1.38.948 1.944.487.563 1.102.938 1.857 1.135.752.196 1.69.19 2.812-.027 1.08-.208 1.935-.596 2.59-1.17a3.445 3.445 0 0 0 1.157-2.08l-1.188.007c-.302 1.597-1.54 1.945-2.88 2.215-2.08.38-3.696-.326-4.112-2.254-.377-2.14 1.315-3.137 3.11-3.52 1.26-.244 2.432-.293 3.154.682l1.085-.41a3.183 3.183 0 0 0-1.71-1.255c-.77-.248-1.667-.273-2.704-.073zm5.342-.946c.76 2.557 1.517 5.113 2.276 7.67 2.488-.74 4.976-1.477 7.465-2.215-.11-.363-.217-.727-.325-1.09l-6.35 1.884c-.23-.778-.46-1.556-.692-2.335 1.907-.566 3.815-1.13 5.722-1.697l-.322-1.085-5.722 1.698-.612-2.065 6.112-1.814-.325-1.096-7.227 2.144zm8.655-2.72c1.12 2.42 2.24 4.84 3.358 7.26l1.003-.462-2.8-6.056c2.588 1.174 5.163 2.383 7.746 3.57.172.15.344.05.516-.042l1.007-.465c-1.12-2.42-2.24-4.84-3.358-7.26l-1.005.463 2.798 6.048c-2.66-1.205-5.303-2.443-7.956-3.66-.437.2-.873.402-1.31.604zm8.785-4.126l.626.952 2.858-1.88.108-.072.054.082 3.717 5.648.973-.64-3.718-5.647-.054-.082.112-.073 2.87-1.89-.625-.952zm8.049-5.512l5.422 5.883c.286-.263.572-.528.86-.79l-2.134-2.315c.94-.876 1.9-1.73 2.826-2.623 1.358.182 2.717.366 4.076.542l1.09-1.004-4.3-.57c.526-.72.754-1.745.26-2.546-.374-.69-1.053-1.28-1.877-1.27-1.105-.027-1.955.808-2.737 1.48l-3.486 3.213zm1.632.046c1.017-.92 2-1.884 3.05-2.768.545-.41 1.313-.93 1.997-.53.584.33.578 1.12.24 1.62-.606 1.017-1.58 1.72-2.416 2.532l-1.127 1.04c-.58-.632-1.163-1.263-1.744-1.894zm7.675-9.362l3.58 8.262.85-1.04-1.117-2.557.003-.005 2.763-3.378 2.728.588.852-1.04-8.807-1.87-.85 1.04zm1.402.28l3.44.738-2.034 2.486-1.406-3.225zm2.082-4.812l6.713 4.353 3.523-5.432-.954-.62-2.818 4.347-.072.11-.085-.054-5.674-3.68z",
    fill: "#c8a400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.8 0 0 .8 -80 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 226.408l-31.478 54.535-15.42 26.702H546.9l-14.715-25.484L500 226.41z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 226.408l-2.356 4.082L500 285.467l2.358-54.977z",
    opacity: 0.62,
    fill: "#17c0eb",
    stroke: "#17c0eb",
    strokeWidth: 0.129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 277.475l-.133.003.134 3.11.135-3.11c-.045 0-.09-.003-.134-.003z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "rotate(72 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "rotate(144 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "rotate(-144 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "rotate(-72 500 285.467)"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(8 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(16 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(24 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(32 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(40 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(48 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(56 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(64 500 285.467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 265.844a44.236 44.236 0 0 0-28.97 10.75L456.376 302c-.5 2.67-.75 5.434-.75 8.25h5.03c0-21.726 17.62-39.344 39.345-39.344 21.727 0 39.344 17.618 39.344 39.344h5.03c0-2.813-.248-5.582-.75-8.25l-14.655-25.406a44.25 44.25 0 0 0-28.97-10.75z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 266.656c-11.764 0-22.44 4.675-30.28 12.25l-12.032 20.844a43.596 43.596 0 0 0-1.28 10.5h4.25c0-21.726 17.616-39.344 39.342-39.344 21.727 0 39.344 17.618 39.344 39.344h4.25a43.86 43.86 0 0 0-1.28-10.53l-12.032-20.814c-7.84-7.574-18.518-12.25-30.282-12.25z",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 267.47c-12.702 0-24.1 5.52-31.938 14.31l-8.718 15.095a42.733 42.733 0 0 0-2.125 13.375h3.436c0-21.726 17.618-39.344 39.344-39.344 21.726 0 39.344 17.618 39.344 39.344h3.437c0-4.673-.74-9.165-2.124-13.375l-8.72-15.095c-7.835-8.788-19.236-14.312-31.937-14.312z",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 268.25c-14.55 0-27.372 7.414-34.906 18.656l-2.813 4.875a41.818 41.818 0 0 0-4.28 18.47h2.656c0-21.726 17.617-39.344 39.343-39.344 21.726 0 39.343 17.618 39.343 39.344H542a41.82 41.82 0 0 0-4.282-18.437l-2.844-4.937C527.338 275.65 514.537 268.25 500 268.25z",
    fill: "#0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 269.062c-22.747 0-41.188 18.44-41.188 41.188h1.844c0-21.727 17.618-39.344 39.344-39.344 21.726 0 39.344 17.617 39.344 39.344h1.844c0-22.748-18.44-41.188-41.188-41.188z",
    fill: "#0cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 269.844c-22.306 0-40.375 18.1-40.375 40.406h1.344c0-21.56 17.47-39.03 39.03-39.03 21.56 0 39.03 17.47 39.03 39.03h1.376c0-22.306-18.1-40.406-40.406-40.406z",
    fill: "#00f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 270.657c-21.863 0-39.588 17.725-39.588 39.59 0 .244.003.49.007.732h.8c-.005-.245-.007-.49-.007-.734 0-21.422 17.366-38.788 38.788-38.788 21.423 0 38.79 17.366 38.79 38.788 0 .245-.003.49-.008.733h.797c.003-.244.006-.49.006-.734 0-21.864-17.72-39.59-39.585-39.59z",
    fill: "purple"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500.395 288.134c-.644-.124-1.226-.484-1.775-.61-.756.725-.835 1.457-.73 2.08.26.14.31.353.877.86s.496.773.462 1.965c-.016.502.07 1.58.578 1.68.548.11.932-.345 1.09-1.16.152-.79.417-1.215.698-1.7.306-1.853-.193-2.51-1.2-3.116z",
    fill: "#510000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.168 283.524c-.595.015-1.528 1.012-1.943.475-.24-.31-.28-.903-.037-1.4.56-1.152 1.124-1.717 2.167-2.33 2.378-1.402 3.89-.952 5.074 1.062 1.097 1.772 2.15 3.73 2.245 5.37.03.502.283 1.41-.156 1.86-1.35 1.39-4.597-1.434-6.498-.987-.64.15-1.377.617-1.98.218-.47-.31-.078-.997.272-1.294.612-.52 1.5-2.366 1.38-3.166-.067-.446-.08.18-.526.19z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.927 282.548c-1.083.445-.966 1.076-1.51 1.59.154.058.766.31 1.364-.3.26-.215.55-.294.678-.363-.305.22-.523.554-.684.684-.404.328-1.034 1.082-1.34 1.845-.307.764-.43 1.673-.376 1.782.056.11.426.78 1.566 1.232 2.03.806 2.417 2.438 4.477 2.438 1.615 0 1.356-1.056 2.647-.832 1.12.194 1.714-.696.636-1.232-1.37-.468-4.092-.192-5.372.033-.413-4.083-.055-2.65-.15-4.405-.098-1.755-.624-1.86.07-3.28-.577.87-1.276.733-2.003.806z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.938 279.795c-.04.223-.077.516-.056.6.087.34.175.693.278.994.115.335.162.578.24.927.082.36.4.5.694.722.37.28.084 1.036.315 1.067.183.025.487-1.07.49-1.246 0-.236-.002-.426-.038-.646a15.3 15.3 0 0 0-.426-.872c-.002-.004-.007-.006-.01-.01a3.652 3.652 0 0 0-.193-.327 4.204 4.204 0 0 0-.786-.863c-.02-.015-.037-.032-.056-.047a3.936 3.936 0 0 0-.258-.187c-.062-.04-.13-.076-.194-.113z",
    fill: "#ff2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.25 287.398c-.72-.188-1.427-.543-2.038-.725-1.2-.36-2.48-1.134-3.366-.814-.317.14-.29.455-.39.91-.042.532-.596 1.318-.136 1.06.685-.382 2.49.734 3.095 1.107.287.177.892.524 1.082 1.022.19.497.092 1.755.04 2.295-.052.566.12 1.835.687 1.987.61.163 1.078-.323 1.316-1.23.23-.88.405-1.387.757-1.915s.756-.756 1.32-.863c.564-.106 1.382.462 1.382-.203 0-.436-.385-.854-.22-1.453.127-.472-.403-.378-.843-.572-1.036-.32-1.97-.42-2.688-.607z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.363 288.902c-.327-.178-2.315-1.478-3.043-1.07-.23.127-.317-.017-.32-.258-.004-.24.11-.594.184-.866.074-.273.195-.792.516-1.062.687-.58 2.27.575 3.108.886-.072.436-.47 2.356-.445 2.37z",
    fill: "#910000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.763 291.36c.916-1.602 1.508-1.396 2.613-1.373.37.008.477-.33.393-.667-.28.624-1.663-.07-2.416.263-1.573.692-1.28 3.77-2.027 4.07.776.65 1.124-1.746 1.436-2.292z",
    fill: "#ff3a3a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.103 307.645l-9.955 17.237h113.708l-9.956-17.237h-93.797z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "n",
    fill: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M449.705 321.364c-1.658 0-3.197.167-4.71.353l-.486.846c2.432-.216 4.696-.65 7.14-.71 3.292.08 6.282.83 9.785.83 1.518.015 3.027-.03 4.526 0 3.5 0 6.49-.75 9.784-.83 3.295.08 6.304.83 9.803.83 1.518.005 3.178-.023 4.53 0 3.5 0 6.474-.75 9.765-.83 3.293.08 6.27.83 9.77.83 1.53.015 3.032-.03 4.542 0 3.5 0 6.49-.75 9.787-.83 3.297.08 6.282.83 9.783.83 1.516.015 3.03-.03 4.53 0 3.5 0 6.475-.75 9.765-.83 2.55.063 4.92.52 7.486.725l-.515-.893c-1.404-.168-2.836-.32-4.37-.32-1.528-.022-3.035.03-4.546 0-3.5 0-6.474.747-9.765.828-3.297-.08-6.284-.83-9.787-.83-1.513-.02-3.03.032-4.526 0-3.5 0-6.493.75-9.786.83-3.293-.08-6.283-.83-9.782-.83-1.522-.02-3.042.032-4.547 0-3.498 0-6.475.75-9.764.83-3.294-.08-6.27-.83-9.77-.83-1.52-.02-3.025.032-4.525 0-3.5 0-6.49.75-9.785.83-3.294-.08-6.283-.83-9.783-.83-1.52-.02-3.043.032-4.547 0z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#k",
    y: -1.113,
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#k",
    y: -2.23,
    fill: "url(#m)"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#n",
    y: -3.344,
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#n",
    y: -6.691,
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.23 307.458l-.123.215h93.79l-.124-.215H453.23zm-.22.377l-.126.22h94.235l-.128-.22h-93.98zm-.2.346l-.204.357h94.792l-.205-.356H452.81zm-.317.552l-.25.433h95.518l-.25-.433h-95.017zm-.4.69l-.25.435h96.317l-.25-.434h-95.816zm-.398.692l-.247.43h97.107l-.247-.43h-96.613zm-.398.692l-.25.43h97.91l-.25-.43h-97.41zm-.43.744l-.304.53h98.877l-.303-.53h-98.27z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.357 312.287c3.45.662 3.782 0 3.782 0zm81.503 0s.33.662 3.782 0z",
    fill: "url(#r)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ccd11e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.63 297.043c-1.708 0-2.23.862-2.23.862-2.737 10.576-11.808 21.333-22.6 21.333h-8.082v10.768c0 .003.012 0 .017 0h61.498l-6.187-10.954c-9.707-1.45-17.64-11.373-20.166-21.147 0 0-.54-.862-2.25-.862z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.63 297.465c-.783 0-1.26.18-1.537.355-.264.165-.315.276-.32.288 0 .007-.016.01-.02.016-1.4 5.323-4.35 10.67-8.333 14.707-4.012 4.07-9.07 6.83-14.605 6.83h-7.674v9.923h60.856l-5.68-10.058c-4.687-.612-8.973-3.163-12.458-6.694-3.986-4.037-6.932-9.383-8.334-14.706l-.017-.016c-.007-.012-.07-.105-.338-.27-.284-.177-.755-.373-1.54-.373z",
    fill: "#97c924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.63 297.465c.147 0 .28.02.406.034.024 3.016 0 8.108 0 10.8-.03 2.34-.83 4.223-2.012 6.44-.547 1.555-.986.964-2.35 2.858-1.83.654-3.186.91-5.138 1.216-2.517.398-8.12.75-10.887.136 3.64-1.068 6.96-3.27 9.77-6.12a30.57 30.57 0 0 0 2.13-2.4 33.663 33.663 0 0 0 3.01-4.48c.352-.626.686-1.248.997-1.893a33.86 33.86 0 0 0 1.25-2.94c.124-.33.245-.667.356-.998.222-.665.417-1.33.592-1.996.002-.006.015-.01.016-.017.007-.012.06-.122.322-.287.136-.085.332-.17.575-.237h.017c.252-.067.554-.118.946-.118z",
    fill: "#ede71f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.938 298.902c-.412 6.034-2.277 13.192-6.644 17.81-1.607 1.337-3.66 2.55-5.646 2.255 6.77-5.51 10.885-13.947 12.29-20.065z",
    fill: "#c6cb24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.494 309.28c-1.002 2.722-4.788 6.747-8.84 10.046-1.15.035-1.76.1-2.804.038 2.468-.225 8.22-5.083 11.644-10.083z",
    fill: "#9ecb34"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#t",
    x: -15.341
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c6cb24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.218 297.91c2.735 10.576 11.79 21.334 22.583 21.334h8.09v10.768c0 .003-.015 0-.017 0h-65.795c-.006 0-.017.003-.017 0v-10.768h8.073c10.792 0 19.863-10.758 22.6-21.333 0 0 .534-.865 2.243-.865 1.708 0 2.243.866 2.243.866z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.975 297.465c.784 0 1.255.196 1.538.372.27.166.332.26.34.27l.016.017c1.4 5.323 4.347 10.67 8.332 14.707 4.017 4.07 9.087 6.83 14.623 6.83h7.64v9.923h-64.98v-9.923h7.675c5.535 0 10.593-2.76 14.605-6.83 3.982-4.037 6.934-9.383 8.334-14.706.002-.007.014-.01.016-.016.006-.012.057-.123.32-.288.28-.174.755-.355 1.54-.355z",
    fill: "#97c924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.263 297.53a3.4 3.4 0 0 0-.242.055h-.017c-.243.066-.436.15-.572.236-.263.166-.313.275-.32.287-.002.006-.016.01-.017.017a28.878 28.878 0 0 1-.949 2.993 34.22 34.22 0 0 1-1.25 2.942 34.21 34.21 0 0 1-.997 1.894 33.634 33.634 0 0 1-3.01 4.477 30.73 30.73 0 0 1-2.13 2.402c-2.81 2.85-6.128 5.05-9.77 6.117 2.766.614 4.033-.057 6.55-.455 1.952-.308 4.21-.563 6.043-1.217 1.364-1.894.9-1.3 1.446-2.854 1.18-2.218 2.906-4.222 3.334-6.68 1.62-3.023 1.903-8.615 1.903-10.214z",
    fill: "#ede71f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.275 298.902c-.412 6.034-2.277 13.192-6.644 17.81-1.605 1.337-3.66 2.55-5.645 2.255 6.77-5.51 10.885-13.947 12.29-20.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.832 309.28c-1.002 2.722-4.788 6.748-8.84 10.046-1.15.035-1.76.1-2.804.038 2.467-.225 8.222-5.083 11.644-10.083z",
    fill: "#9ecb34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.95 297.584h.02c.24.067.434.15.57.236.264.165.315.274.32.286.003.006.017.01.02.018.174.665.37 1.333.59 1.996.112.332.235.665.358.995a33.6 33.6 0 0 0 1.25 2.942c.31.645.644 1.268.997 1.895a33.634 33.634 0 0 0 3.01 4.477 30.73 30.73 0 0 0 2.13 2.4c2.81 2.85 6.128 5.446 9.768 6.513-7.245.028-10.39-.63-13.022-4.016-2.632-3.387-3.605-4.868-4.14-6.937-.534-2.068-2.025-6.57-1.87-10.806z",
    fill: "#ede71f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.476 298.902c.412 6.034 2.22 12.006 6.587 16.625 1.607 1.337 3.66 2.55 5.646 2.255-7.336-5.002-10.83-12.762-12.234-18.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.75 297.043c-1.71 0-2.25.862-2.25.862-2.522 9.747-11.824 22.318-21.496 23.81l-4.79 8.29h49.015V318.66c-8.826-2.37-15.89-11.63-18.25-20.753 0 0-.522-.862-2.23-.862z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.75 297.465c-.785 0-1.256.196-1.54.372-.268.166-.33.26-.337.27l-.017.017c-1.402 5.323-4.678 10.705-8.08 14.99-3.402 4.283-9.72 8.617-14.042 9.076l-4.282 7.393h48.06V318.89c-3.554-1.09-6.8-3.267-9.552-6.06-3.982-4.037-6.934-9.383-8.334-14.706-.002-.007-.015-.01-.017-.016-.007-.012-.06-.123-.322-.288-.28-.174-.755-.355-1.54-.355z",
    fill: "#97c924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.445 298.903c-.617 9.043-5.653 20.454-11.34 22.42-1.855.64-5.1.864-6.227 1.008 9.948-4.73 15.828-15.852 17.567-23.427z",
    fill: "#93bc30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.746 297.465c-.147 0-.28.02-.406.034-.023 3.016 0 8.108 0 10.8.03 2.34.83 4.223 2.012 6.44.07.195.136.355.203.49.41 1.087.713 1.464 2.282 2.655 4.987 3.787 11.17 4.353 14.808 4.04-1.14-.898-2.358-1.715-3.43-2.467 1.71-.056 3.35-.25 4.512-.508-3.64-1.067-6.96-3.27-9.77-6.12a30.523 30.523 0 0 1-1.403-1.554c-.21-.292-.5-.698-.592-.812-1.118-1.4-2.263-2.947-3.145-4.513a34.164 34.164 0 0 1-.997-1.893 34.023 34.023 0 0 1-1.606-3.938 31.676 31.676 0 0 1-.592-1.996c-.002-.006-.015-.01-.017-.017-.006-.012-.057-.122-.32-.287a2.207 2.207 0 0 0-.576-.237h-.018a3.614 3.614 0 0 0-.946-.118z",
    fill: "#ede71f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.446 298.902c.412 6.034 2.277 13.192 6.644 17.81 1.606 1.337 3.66 2.55 5.646 2.255-6.77-5.51-10.886-13.947-12.29-20.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.613 307.247c2.37 5.837 8.37 11.29 14.543 14.954 1.15.036 1.492.004 2.537-.06-4.42-2.37-11.54-5.753-17.08-14.893z",
    fill: "#9ecb34"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#w",
    x: -15.43,
    fill: "#c6cb24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M556.5 324.692c-.574.203-4.42-.19-6.433-.044l-1.28.336c-1.123-.008-2.238.024-3.33 0-3.602 0-6.65.948-10.075.948-3.433 0-6.47-.948-10.075-.948-1.12-.008-2.234.025-3.33 0-3.602 0-6.647.948-10.076.948-3.428 0-6.472-.948-10.074-.948-1.13-.007-2.242.023-3.348 0-3.602 0-6.632.948-10.058.948-3.43 0-6.456-.948-10.058-.948-.267 0-.516.01-.776.017-.178-.003-.377-.016-.557-.016-.12 0-.223-.003-.34 0-.117-.003-.237 0-.356 0-.18 0-.345.013-.523.017-.258-.007-.51-.016-.778-.016-3.606 0-6.643.95-10.076.948-3.43 0-6.473-.948-10.075-.948-.26 0-.52.01-.775.017-.18-.003-.34-.016-.522-.016-.124 0-.252-.003-.374 0-.118-.003-.238 0-.357 0-.18 0-.362.013-.54.017-.26-.007-.51-.016-.776-.016-2.88 0-6.218.607-8.936.85l-6.272 10.858 62.972-.007 64.375.007z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.993 323.11c-.2 0-.398 0-.596.008-3.24.095-5.564 1.115-11.2 1.115-5.638 0-6.22-1.02-12.584-.88-5.947.132-8.443 1.263-11.67 1.218-3.228-.043-8.473-.696-12.51-.274-4.037.423-8.828 1.284-11.973 1.29-3.91-.016-7.82-.73-11.906-.323-4.087.406-5.997 1.5-11.063 1.485-4.355-.013-9.082-.698-12.745-.695-3.435.003-7.267.957-10.086 1.443l-.844 1.464c2.247-.26 8.55-1.218 10.802-1.277 2.344-.06 10.717.483 15.335.325 4.618-.16 5.158-1.172 10.618-1.172 3.802 0 6.667.4 10.567.4 2.434 0 4.643-1.243 8.343-1.243.936-.027 1.865-.06 2.794-.09 3.12-.516 8.384.044 12.048.23 3.315.174 5.457-.614 8.914-.73 1.496-.067 2.998-.065 4.474-.147 3.46-.115 6.422.64 9.68.624 3.25-.2 6.403-.922 9.86-1.037 1.51-.07 2.998-.072 4.49-.148 2.287-.076 5.837.078 8.273.5l-.84-1.45c-2.38-.075-5.31-.634-8.18-.634z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "M450.312 334.748c-3.457 0-6.402.853-9.652.945-1.21-.033-2.367-.183-3.535-.345l-.49.85c.486.032.975.063 1.488.063 1.502.02 2.99-.035 4.474 0 3.457 0 6.382-.85 9.634-.944 3.255.092 6.207.945 9.667.945 1.5.02 2.993-.035 4.474 0 3.458 0 6.413-.852 9.667-.944 3.256.092 6.23.945 9.687.945 1.495.02 2.993-.035 4.47 0 3.457 0 6.4-.852 9.652-.944 3.253.092 6.19.945 9.65.945 1.51.02 2.998-.035 4.49 0 3.457 0 6.41-.852 9.666-.944 3.257.092 6.21.945 9.67.945 1.495.02 2.99-.035 4.47 0 3.456 0 6.4-.852 9.65-.944 3.254.092 6.21.945 9.667.945 1.5.02 2.995-.035 4.473 0 .605 0 1.196-.033 1.778-.076l-.462-.797c-1.064.144-2.133.276-3.235.306-3.254-.092-6.195-.945-9.652-.945-1.51-.02-2.996.03-4.49 0-3.457 0-6.396.853-9.648.945-3.257-.09-6.206-.945-9.666-.945-1.496-.02-2.993.03-4.473 0-3.458 0-6.413.853-9.667.945-3.254-.092-6.21-.945-9.666-.945-1.503-.02-3.003.03-4.49 0-3.458 0-6.4.853-9.65.945-3.253-.092-6.194-.945-9.65-.945-1.507-.02-2.99.03-4.475 0-3.46 0-6.41.854-9.666.945-3.255-.092-6.21-.945-9.667-.945-1.502-.02-3.006.03-4.49 0z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#z",
    y: -1.289
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#z",
    y: -2.575
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#A",
    y: -3.867
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#A",
    y: -7.729
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443.846 324.705l-2.427 4.19c2.838-.47 7.1-1.702 10.633-1.705 3.663-.003 8.082.903 12.438.916 5.067.014 6.977-1.08 11.064-1.485 4.086-.406 7.998.528 11.906.546 3.145-.007 7.936-1.09 11.973-1.512 4.037-.422 7.737.293 12.603.37 4.866.074 5.63-1.18 11.576-1.312 6.366-.14 6.947.878 12.584.878 4.242.23 7.883-.854 11.666-1.12 3.784-.27 5.54.042 8.305.108l-1.838-3.253c-.032 0-.062.003-.093.004l-101.246 2.225z",
    fill: "#97c924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.067 324.648s2.71.148 3.847.276a91.39 91.39 0 0 0 2.955.253l-.37-.485c-.574.203-4.42-.19-6.433-.044z",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320 179.9l-25.713 44.548L268 269.968l51.438-.007 52.562.007-25.723-44.546L320 179.9zm0 2.4l25.24 43.723 24.68 42.742-50.482-.003-49.36.003 25.247-43.716z",
    fill: "#c8a400"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNi);
export default __webpack_public_path__ + "static/media/ni.d50998d3f55b5e746ab0daa0fa32a6b0.svg";
export { ForwardRef as ReactComponent };